module.exports = __webpack_public_path__ + "static/media/tWalberg.ddb05f7e.jpeg";